export default "__VITE_ASSET__BPElqkoC__"